<app-skeleton [loading]="loading" height="140px">
    <app-source-detail [baseInfo]="baseInfo"
        [capacityPercentData]="capacityPercentData"
        [detail]="detail"
        [event]="item"
        [loading]="updateLoading"
        icon="#infigo-fileSystem"
        type="fileSystem"
    >
    </app-source-detail>
</app-skeleton>



